
import { useState, useEffect } from "react";

interface AppStoreApp {
  trackId: number;
  bundleId: string;
  appName: string;
  iconUrl?: string;
  description?: string;
  category: string;
  version?: string;
  developerName: string;
}

export const useAppStoreSearch = (searchQuery: string) => {
  const [data, setData] = useState<AppStoreApp[]>([]);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    if (!searchQuery || searchQuery.length < 2) {
      setData([]);
      return;
    }

    setIsLoading(true);
    
    // Use iTunes Search API for App Store search
    const searchApps = async () => {
      try {
        const response = await fetch(
          `https://itunes.apple.com/search?term=${encodeURIComponent(searchQuery)}&country=US&media=software&limit=20`
        );
        
        if (!response.ok) {
          throw new Error('Search failed');
        }
        
        const result = await response.json();
        
        const apps: AppStoreApp[] = result.results.map((item: any) => ({
          trackId: item.trackId,
          bundleId: item.bundleId,
          appName: item.trackName,
          iconUrl: item.artworkUrl100 || item.artworkUrl60,
          description: item.description,
          category: item.primaryGenreName,
          version: item.version,
          developerName: item.artistName
        }));
        
        setData(apps);
      } catch (error) {
        console.error('App Store search error:', error);
        setData([]);
      } finally {
        setIsLoading(false);
      }
    };

    const debounceTimer = setTimeout(searchApps, 300);
    
    return () => clearTimeout(debounceTimer);
  }, [searchQuery]);

  return { data, isLoading };
};
